module.exports = __webpack_public_path__ + "img/contact.36ebaae.svg";